'use strict';

import React from 'react';
import {h, Fragment} from 'preact';

export default function BreadcrumbsMobile(props) {
    return '';
}
